// extracted by mini-css-extract-plugin
export default {"item":"glossary-item_item__xBFJR","title":"glossary-item_title__QXTHr","description":"glossary-item_description__yw1ts"};